import { render, staticRenderFns } from "./cuccAuth.vue?vue&type=template&id=0f1f4b04&"
import script from "./cuccAuth.vue?vue&type=script&lang=js&"
export * from "./cuccAuth.vue?vue&type=script&lang=js&"
import style0 from "./cuccAuth.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports